import { AutocompleteSource } from "@algolia/autocomplete-core";
import { getAlgoliaResults } from "@algolia/autocomplete-js";

import { isDefined } from "@utils/helpers";

import { AlgoliaClient } from "@services/algolia/types/client.types";
import { AlgoliaSearchResult } from "@services/algolia/types/search.types";

import {
    CONTENT_PAGES_COUNT,
    CONTENT_PAGES_SOURCE_ID,
} from "@components/Search/SearchAutocomplete/autoCompleteConstants";
import { ContentPagesSourceType } from "@components/Search/SearchAutocomplete/autocompleteTypes";
import transformQueryForMultiSku from "@components/Search/SearchAutocomplete/helpers/multiSku.helpers";

const contentPagesSource = (
    indexName: string,
    searchClient?: AlgoliaClient,
): AutocompleteSource<ContentPagesSourceType> => ({
    sourceId: CONTENT_PAGES_SOURCE_ID,
    getItemInputValue({ item }) {
        return item.title;
    },
    getItems({ setContext, state, query }) {
        return isDefined(searchClient)
            ? getAlgoliaResults<ContentPagesSourceType>({
                  searchClient: searchClient,
                  queries: [
                      {
                          indexName: indexName,
                          params: {
                              hitsPerPage: CONTENT_PAGES_COUNT,
                              query: query,
                              clickAnalytics: true,
                              ruleContexts: ["enable-redirect-url"],
                          },
                      },
                  ].map(transformQueryForMultiSku),
                  transformResponse({ results }) {
                      const contentPagesResult =
                          results[0] as AlgoliaSearchResult<ContentPagesSourceType>;

                      const context = state.context;
                      context.nbContentPagesHits = contentPagesResult.nbHits;
                      setContext(context);

                      return contentPagesResult.hits;
                  },
              })
            : [];
    },
});

export { contentPagesSource };
